/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_OPEN_REG_REPORT } from "../graphql/openRegReport.query";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { pretty } from "@vlinder-web/utils-react";
import { ManageOpenRegistraionService } from "../../ManageOpenRegisteration";
import { GetOpenReg } from "../graphql/getOpenReg.query";
import { GET_PRESENTATION } from "../graphql/getPresentationList.query";

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};
const is = require("is_js");
export interface IopenRegReportMethods extends IPluginMethodMap {
    getopenRegReport(args: any): Promise<any>;
}
const getSrv = () => {
    const app = VApplication.getInstance();
    return app.getSync(
        "services.ManageOpenRegistraionService"
    ) as ManageOpenRegistraionService;
};
export class OpenRegReportService implements IAgentPlugin {
    readonly methods: IopenRegReportMethods;

    constructor() {
        this.methods = {
            getopenRegReport: this.getopenRegReport.bind(this),
        };
    }

    async getopenRegReport(args: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        let filter = {};
        console.log("args?.criteria==>", args?.criteria)
        if (args?.criteria) {
            const searchType = this.determineSearchType(args?.criteria);
            if (searchType && searchType !== null) {
                if (searchType === "multi") {
                    filter = this.getMultiFilter(args?.criteria);
                }
                else {
                    filter = this.convertCriteria(args?.criteria);
                }
            }
        }

        const renderPresentation = async () => {
            const data1 = await getSrv()?.getInviteUser();

            let presentation =
                data1?.response?.getOpenInvite[0]?.presentation?.id ?? "";

            return presentation;
        };
        try {
            if (client) {
                const id = await client.query({
                    query: GetOpenReg,
                    variables: {},
                    fetchPolicy: "network-only",
                });
                if (id?.data) {
                    const _res = await client.query({
                        query: GET_PRESENTATION,
                        variables: {},
                        fetchPolicy: "network-only",
                    });
                    const activeItem = _res?.data?.getPresentations?.content.find(
                        (item: any) => item.status === "active"
                    );
                    let activePresentation =
                        activeItem && activeItem?.id
                            ? activeItem?.id
                            : _res?.data?.getPresentations?.content[0]?.id;
                    let defaultPresentation = args?.criteria?.presentation ??
                        args?.presentation ??
                        activePresentation;
                    filter = {
                        ...filter,
                        Referal___presentation: {
                            eq: defaultPresentation
                        }
                    }
                    const res = await client.query({
                        query: GET_OPEN_REG_REPORT,
                        variables: {
                            presentationId: defaultPresentation,
                            invitedByUserEmail: id?.data?.getOpenReg?.user?.email,
                            filter: filter,
                        },
                        fetchPolicy: "network-only",
                    });
                    if (res?.data) {
                        return res
                    }
                }
            }
        } catch (err: any) {
            let _display_message =
                err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.find((item: any) => item.extensions);
            if (_display_message?.extensions?.display_message) {
                throw Error(_display_message?.extensions?.display_message);
            }

            throw err;
        }
    }

    private determineSearchType(criteria: any) {
        if (Object.keys(criteria).length === 0) {
            return "default";
        }
        else if (Object.keys(criteria)[0] === "0") {
            return "multi";
        } else {
            return "normal";
        }
    }

    private convertCriteria(criteria: any) {
        const result: any = {};
        for (const key in criteria) {
            if (key != "presentation") {
                if (key === "inviteStatus" && criteria[key] === "all") {
                    console.log("not filter")
                }
                else {
                    result[key] = { contains: criteria[key] };
                }
            }
            console.log("key in convert criteria", key, criteria[key]);
        }
        return result;
    }

    private getMultiFilter(criteria: any) {
        const transformedCriteria: any = {};
        for (const key in criteria) {
            if (criteria.hasOwnProperty(key)) {
                const { key: filterKey, filters } = criteria[key];
                const { inputData } = filters;
                const filterType = Object.keys(filters).find(
                    (key) => key !== "inputData"
                );

                transformedCriteria[inputData.id] = {
                    [filterType.toLowerCase().replace("equal", "eq")]:
                        filters[filterType],
                };
            }
        }
        return transformedCriteria;
    }
}
